import React from 'react'
import { ButtonGroup } from 'react-bootstrap'
import { AssetTypeEnum } from '@ztechapps/common.contract'
import type { ListFieldConfig } from '@ztechapps/common.hook'
import { ListFieldTypeEnum } from '@ztechapps/common.hook'
import { DataTool } from '../DataTool'
import { BusyButton } from '@ztechapps/webui.button'
import { NullComponent } from '@ztechapps/webui.util'
import { useAssetPageContext } from './Context'
import { UploadViaUppy } from './UploadViaUppy'

const fieldsConfig: ListFieldConfig = {
  title: { name: 'title', displayName: 'Title', defaultOnSearch: true },
  subtitle: { name: 'subtitle', displayName: 'Subtitle' },
  type: {
    name: 'type',
    displayName: 'Type',
    excludeOnSearch: true,
    type: ListFieldTypeEnum.select,
    fieldSettings: {
      listValues: Object.values(AssetTypeEnum),
    },
  },
}

const OtherButtons = () => {
  const { viewMode, setViewMode } = useAssetPageContext()

  return (
    <ButtonGroup>
      <UploadViaUppy />
      <BusyButton
        icon="th-large"
        title="Grid view"
        variant={viewMode === 'grid' ? 'primary' : 'outline-secondary'}
        active={viewMode === 'grid'}
        onClick={() => setViewMode('grid')}
      />
      <BusyButton
        icon="list"
        title="List view"
        variant={viewMode === 'list' ? 'primary' : 'outline-secondary'}
        active={viewMode === 'list'}
        onClick={() => setViewMode('list')}
      />
    </ButtonGroup>
  )
}

export const DataAction = () => {
  const { localListAction } = useAssetPageContext()

  return (
    <div className="d-flex justify-content-end">
      <DataTool
        {...localListAction}
        fieldsConfig={fieldsConfig}
        filterCategory="filter_asset_container"
        components={{ other: OtherButtons, sort: NullComponent, refresh: NullComponent }}
        searchPlaceHolder="Search assets."
      />
    </div>
  )
}
